import { Box, Heading } from 'lucid-components-react';
import React from 'react';

import Link from 'components/link/link';
import {
  Drupal_ParagraphFeatureGridItem,
  Drupal_ParagraphSeoImage
} from 'generated/graphql';
import { Text } from 'theme/typography';

interface Props {
  item: Drupal_ParagraphFeatureGridItem;
  buttonText: string;
  hasBorder?: boolean;
}

const FeatureGridItem = ({ item, buttonText, hasBorder = true }: Props) => {
  const image =
    item.fieldFeatureImage &&
    (item.fieldFeatureImage.entity as Drupal_ParagraphSeoImage);
  return (
    <Box
      css={theme => ({
        display: 'block',
        height: '100%',
        padding: '2rem 1rem',
        ...(hasBorder && {
          borderBottom: `1px solid ${theme.colors.coolGrey[30]}`
        })
      })}
    >
      {image && image.fieldImageLink && (
        <img
          alt={image.fieldAltText!}
          className="feature-grid-item__image"
          css={{
            maxHeight: '64px',
            maxWidth: '42%'
          }}
          src={image.fieldImageLink}
        />
      )}
      <Heading my={3} variant="subheadXXS">
        {item.fieldFeatureTitle}
      </Heading>
      <Text textStyles="bodySmall">{item.fieldFeatureDescription}</Text>
      {item.fieldFeatureLink && (
        <Link
          hasArrow
          secondary
          className="feature-grid-item__link"
          to={item.fieldFeatureLink}
        >
          {buttonText}
        </Link>
      )}
    </Box>
  );
};

export default FeatureGridItem;
